import { Stack, Typography } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';

export const NoDataOverlay = () => {
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        height: '300px',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography color='textSecondary'>{t('No data available')}</Typography>
    </Stack>
  );
};
